import { Component } from '@angular/core';

/**
 * Home app
 */
@Component({
  template: '<router-outlet></router-outlet>',
})
export class OutletComponent {
  
}